(function () {
  let wasOpen = false;

  const observer = new MutationObserver(function () {
    // Look for Printify's personalization popup/modal
    const printifyPopup =
      document.querySelector('[class*="printify"]') ||
      document.querySelector('[id*="printify"]');

    if (printifyPopup) {
      wasOpen = true;
    }

    // If the popup was open and is now gone
    if (wasOpen && !printifyPopup) {
      wasOpen = false;

      // Wait for Printify to finish closing
      setTimeout(function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, 300);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();